<template>
  <div class="rsm-end">
    <div class="rsm-end__icon">✅</div>
    <h2 class="rsm-end__title">C'est tout pour cette section</h2>
    <p class="rsm-end__body">
      Merci de votre participation. Veuillez continuer avec le questionnaire.
    </p>
  </div>
</template>

<script>
import { setValue, closeMaterials } from '../lib/predictiv.js';

export default {
  props: {
    trackingData: { type: Object, default: () => ({}) }
  },
  mounted() {
    const d = this.trackingData;

    // Save all tracking data to Predictiv
    setValue('rsm_condition',            d.condition || '');
    setValue('rsm_feed_type',            d.feedType || '');
    setValue('rsm_posts_viewed',         d.postsViewed || 0);
    setValue('rsm_harmful_posts_viewed', d.harmfulPostsViewed || 0);
    setValue('number_harmful_video_viewed_pre_intervention',  d.harmfulPreCount || 0);
    setValue('number_harmful_video_viewed_post_intervention', d.harmfulPostCount || 0);
    setValue('number_neutral_video_viewed_pre_intervention',  d.neutralPreCount || 0);
    setValue('number_neutral_video_viewed_post_intervention', d.neutralPostCount || 0);
    setValue('rsm_time_in_feed_ms',      d.timeInFeedMs || 0);
    setValue('rsm_chatbot_triggered',    d.chatbotTriggered ? 1 : 0);
    setValue('rsm_chatbot_completed',    d.chatbotCompleted ? 1 : 0);
    setValue('rsm_exercise_selected',    d.exerciseSelected || '');
    setValue('rsm_exercise_completed',   d.exerciseCompleted ? 1 : 0);
    setValue('rsm_chatbot_answers',      JSON.stringify(d.chatbotAnswers || []));

    // Extended analytics. No Predictiv-side setup needed: Predictiv flattens whatever keys
    // land in this question's value into CSV columns automatically (SurveyJs::Question::QuestionBase#serialize
    // in predictiv-rebuild), so any key sent via setValue() just shows up once a respondent has it.
    setValue('rsm_scroll_up',            d.nbScrollUp || 0);
    setValue('rsm_scroll_down',          d.nbScrollDown || 0);
    setValue('rsm_harmful_time_ms',      Math.min(d.harmfulTimeMs || 0, d.timeInFeedMs || 0));
    setValue('rsm_videos_viewed',        JSON.stringify(d.videosVus || []));
    setValue('rsm_video_events',         JSON.stringify(d.videoEvents || []));
    setValue('rsm_time_per_video',       JSON.stringify(d.tempsParVideoTotal || {}));
    setValue('rsm_time_per_video_cont',  JSON.stringify(d.tempsParVideosCont || {}));
    setValue('rsm_interaction_events',   JSON.stringify(d.interactionEvents || []));
    setValue('rsm_likes',                JSON.stringify(d.clicLiker || []));
    setValue('rsm_comments',             JSON.stringify(d.clicCommenter || []));
    setValue('rsm_shares',               JSON.stringify(d.clicPartager || []));
    setValue('rsm_reports',              JSON.stringify(d.clicSignaler || []));
    setValue('rsm_intervention_shown',     d.interventionShown ? 1 : 0);
    setValue('rsm_intervention_completed', d.interventionCompleted ? 1 : 0);
    setValue('rsm_quiz_q1_guess',  d.quizAnswers ? d.quizAnswers.q1Guess : '');
    setValue('rsm_quiz_q2_answer', d.quizAnswers ? d.quizAnswers.q2Answer : '');
    setValue('rsm_signaler_exit',        d.signalerExit ? 1 : 0);
    setValue('rsm_signaler_exit_time',   d.signalerExitTime != null ? d.signalerExitTime : '');
    setValue('rsm_signaler_technique',   d.signalerTechnique || '');

    // Close the material after a short delay
    setTimeout(() => {
      closeMaterials();
    }, 1500);
  }
};
</script>
